<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2019-11-04',
        items: [

          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'プリチケパック2',
            id          : 'AM-270',
            rare        : 'HR',
            name        : 'シンデレラプリンセスオレンジワンピ',
            imgUrl      : '/images/items/AM-270.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-271',
            rare        : 'HR',
            name        : 'シンデレラプリンセスオレンジシューズ',
            imgUrl      : '/images/items/AM-271.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-272',
            rare        : 'HR',
            name        : 'シンデレラプリンセスオレンジヘアアクセ',
            imgUrl      : '/images/items/AM-272.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'プリチケパック2',
            id          : 'AM-221',
            rare        : 'PR',
            name        : 'ディスコティックラブアクアトップス',
            imgUrl      : '/images/items/AM-221.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-222',
            rare        : 'PR',
            name        : 'ディスコティックラブアクアスカート',
            imgUrl      : '/images/items/AM-222.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-223',
            rare        : 'PR',
            name        : 'ディスコティックラブアクアシューズ',
            imgUrl      : '/images/items/AM-223.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-224',
            rare        : 'PR',
            name        : 'ディスコティックラブアクアヘアアクセ',
            imgUrl      : '/images/items/AM-224.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-225',
            rare        : 'PR',
            name        : 'スーパーサイリウムひびきアナザーワンピ',
            imgUrl      : '/images/items/AM-225.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-226',
            rare        : 'PR',
            name        : 'スーパーサイリウムひびきアナザーシューズ',
            imgUrl      : '/images/items/AM-226.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-227',
            rare        : 'PR',
            name        : 'スーパーサイリウムひびきアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-227.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            rare        : 'PR',
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-228',
            rare        : 'PR',
            name        : 'チームゆめサイリウムゆいアナザーワンピ',
            imgUrl      : '/images/items/AM-228.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-229',
            rare        : 'PR',
            name        : 'チームゆめサイリウムゆいアナザーシューズ',
            imgUrl      : '/images/items/AM-229.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-230',
            rare        : 'PR',
            name        : 'チームゆめサイリウムゆいアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-230.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'プリチケパック2',
            id          : 'AM-231',
            rare        : 'SR',
            name        : 'チアリーダーレッドトップス',
            imgUrl      : '/images/items/AM-231.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-232',
            rare        : 'SR',
            name        : 'チアリーダーレッドスカート',
            imgUrl      : '/images/items/AM-232.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-233',
            rare        : 'SR',
            name        : 'チアリーダーレッドシューズ',
            imgUrl      : '/images/items/AM-233.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-234',
            rare        : 'SR',
            name        : 'チアリーダーレッドヘアアクセ',
            imgUrl      : '/images/items/AM-234.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-235',
            rare        : 'SR',
            name        : 'ディアクラウンパープルサイリウムワンピ',
            imgUrl      : '/images/items/AM-235.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-236',
            rare        : 'SR',
            name        : 'ディアクラウンパープルサイリウムシューズ',
            imgUrl      : '/images/items/AM-236.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-237',
            rare        : 'SR',
            name        : 'ディアクラウンパープルサイリウムヘアアクセ',
            imgUrl      : '/images/items/AM-237.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-238',
            rare        : 'SR',
            name        : 'サニーズーホワイトサイリウムワンピ',
            imgUrl      : '/images/items/AM-238.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-239',
            rare        : 'SR',
            name        : 'サニーズーホワイトサイリウムシューズ',
            imgUrl      : '/images/items/AM-239.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-240',
            rare        : 'SR',
            name        : 'サニーズーホワイトサイリウムヘアアクセ',
            imgUrl      : '/images/items/AM-240.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'プリチケパック2',
            id          : 'AM-241',
            rare        : 'R',
            name        : 'サマーメイドブラックレッドトップス',
            imgUrl      : '/images/items/AM-241.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-242',
            rare        : 'R',
            name        : 'サマーメイドブラックレッドスカート',
            imgUrl      : '/images/items/AM-242.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-243',
            rare        : 'R',
            name        : 'サマーメイドブラックレッドシューズ',
            imgUrl      : '/images/items/AM-243.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-244',
            rare        : 'R',
            name        : 'サマーメイドブラックレッドヘアアクセ',
            imgUrl      : '/images/items/AM-244.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-245',
            rare        : 'R',
            name        : 'にゃんにゃんにゃ～すグリーントップス',
            imgUrl      : '/images/items/AM-245.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-246',
            rare        : 'R',
            name        : 'にゃんにゃんにゃ～すグリーンスカート',
            imgUrl      : '/images/items/AM-246.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-247',
            rare        : 'R',
            name        : 'にゃんにゃんにゃ～すグリーンシューズ',
            imgUrl      : '/images/items/AM-247.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-248',
            rare        : 'R',
            name        : 'にゃんにゃんにゃ～すグリーンヘアアクセ',
            imgUrl      : '/images/items/AM-248.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-249',
            rare        : 'R',
            name        : 'カッパーフェザートップス',
            imgUrl      : '/images/items/AM-249.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-250',
            rare        : 'R',
            name        : 'カッパーフェザースカート',
            imgUrl      : '/images/items/AM-250.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-251',
            rare        : 'R',
            name        : 'カッパーフェザーシューズ',
            imgUrl      : '/images/items/AM-251.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-252',
            rare        : 'R',
            name        : 'カッパーフェザーヘアアクセ',
            imgUrl      : '/images/items/AM-252.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'プリチケパック2',
            id          : 'AM-253',
            rare        : 'R',
            name        : 'ゆるふわラブリーブラックワンピ',
            imgUrl      : '/images/items/AM-253.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-254',
            rare        : 'R',
            name        : 'ゆるふわラブリーブラックシューズ',
            imgUrl      : '/images/items/AM-254.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-255',
            rare        : 'R',
            name        : 'ゆるふわラブリーブラックヘアアクセ',
            imgUrl      : '/images/items/AM-255.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            rare        : 'R',
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-256',
            rare        : 'R',
            name        : 'ピクニックギンガムイエローケープワンピ',
            imgUrl      : '/images/items/AM-256.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-257',
            rare        : 'R',
            name        : 'ピクニックギンガムイエローシューズ',
            imgUrl      : '/images/items/AM-257.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-258',
            rare        : 'R',
            name        : 'ピクニックギンガムイエローヘアアクセ',
            imgUrl      : '/images/items/AM-258.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'プリチケパック2',
            id          : 'AM-259',
            rare        : 'N',
            name        : 'パンクキャットブルートップス',
            imgUrl      : '/images/items/AM-259.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 7 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-260',
            rare        : 'N',
            name        : 'パンクキャットブルースカート',
            imgUrl      : '/images/items/AM-260.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-261',
            rare        : 'N',
            name        : 'パンクキャットブルーシューズ',
            imgUrl      : '/images/items/AM-261.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 10 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-262',
            rare        : 'N',
            name        : 'パンクキャットブルーヘアアクセ',
            imgUrl      : '/images/items/AM-262.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 7 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-263',
            rare        : 'N',
            name        : 'エレガントパーティーパープルトップス',
            imgUrl      : '/images/items/AM-263.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-264',
            rare        : 'N',
            name        : 'エレガントパーティーパープルスカート',
            imgUrl      : '/images/items/AM-264.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-265',
            rare        : 'N',
            name        : 'エレガントパーティーパープルシューズ',
            imgUrl      : '/images/items/AM-265.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-266',
            rare        : 'N',
            name        : 'エレガントパーティーパープルヘアアクセ',
            imgUrl      : '/images/items/AM-266.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック2',
            id          : 'AM-267',
            rare        : 'N',
            name        : 'クーリッシュブルゾン＆レッドロンT',
            imgUrl      : '/images/items/AM-267.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-268',
            rare        : 'N',
            name        : 'クーリッシュレッドスニーカー',
            imgUrl      : '/images/items/AM-268.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            id          : 'AM-269',
            rare        : 'N',
            name        : 'クーリッシュレッドヘアアクセ',
            imgUrl      : '/images/items/AM-269.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック2',
            rare        : 'N',
          }),
        ],
      }
    },

    computed: {
      itemsHR () {
        return _.where(this.items, {  rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.items, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.items, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.items, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.items, {  rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>
    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>
    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>
    <template #col4>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <Status :date="date" :items="items" :showHR="true" />
    </template>
    <template #col5>
    </template>
    <template #col6>
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // (position: absolute になっている) PC 画面のみ
  .Page ::v-deep .Status {
    bottom: 0;
  }
</style>
